// Datos mock (hardcodeados) para el mockup del módulo "Mesa Directiva".
// No hay backend real: esta información sólo alimenta las vistas de demostración.

export const periodo = {
  nombre: 'Mesa Directiva 2026 – 2027',
  inicio: '15/01/2026',
  fin: '14/01/2028',
  estado: 'Activa'
}

export const cargosDisponibles = [
  'Presidente',
  'Vicepresidente',
  'Secretario',
  'Tesorero',
  'Vocal',
  'Administrador'
]

export const miembros = [
  { id: 1, name: 'Roberto Fuentes Salinas', cargo: 'Presidente', email: 'roberto.fuentes@mesadirectiva.mx', phone: '55 1234 5678', periodo: '2026 – 2027', status: 'Activo' },
  { id: 2, name: 'Adriana Cess Nájera', cargo: 'Vicepresidente', email: 'adriana.cess@mesadirectiva.mx', phone: '55 2345 6789', periodo: '2026 – 2027', status: 'Activo' },
  { id: 3, name: 'Luis Fernando Ortiz', cargo: 'Secretario', email: 'luis.ortiz@mesadirectiva.mx', phone: '55 3456 7890', periodo: '2026 – 2027', status: 'Activo' },
  { id: 4, name: 'Marcela Duarte Reyes', cargo: 'Tesorero', email: 'marcela.duarte@mesadirectiva.mx', phone: '55 4567 8901', periodo: '2026 – 2027', status: 'Activo' },
  { id: 5, name: 'Jorge Iván Camacho', cargo: 'Vocal', email: 'jorge.camacho@mesadirectiva.mx', phone: '55 5678 9012', periodo: '2026 – 2027', status: 'Activo' },
  { id: 6, name: 'Paola Ibarra Solís', cargo: 'Vocal', email: 'paola.ibarra@mesadirectiva.mx', phone: '55 6789 0123', periodo: '2026 – 2027', status: 'Inactivo' }
]

export const reuniones = [
  {
    id: 1,
    titulo: 'Sesión Ordinaria — Septiembre',
    fecha: '18/09/2026',
    hora: '18:00',
    lugar: 'Salón de usos múltiples',
    modalidad: 'Presencial',
    descripcion: 'Sesión ordinaria mensual para revisar temas de seguridad, mantenimiento de áreas comunes y dar seguimiento a solicitudes pendientes.',
    estado: 'Próxima',
    asistentesConfirmados: 5,
    totalParticipantes: 6,
    agenda: [
      'Seguridad de la residencia',
      'Mantenimiento de áreas comunes',
      'Solicitudes pendientes',
      'Nuevos acuerdos'
    ],
    participantes: [
      { name: 'Roberto Fuentes Salinas', cargo: 'Presidente', asistencia: 'Confirmado' },
      { name: 'Adriana Cess Nájera', cargo: 'Vicepresidente', asistencia: 'Confirmado' },
      { name: 'Luis Fernando Ortiz', cargo: 'Secretario', asistencia: 'Confirmado' },
      { name: 'Marcela Duarte Reyes', cargo: 'Tesorero', asistencia: 'Confirmado' },
      { name: 'Jorge Iván Camacho', cargo: 'Vocal', asistencia: 'Confirmado' },
      { name: 'Paola Ibarra Solís', cargo: 'Vocal', asistencia: 'Sin responder' }
    ],
    acuerdosGeneradosIds: [1, 2]
  },
  {
    id: 2,
    titulo: 'Revisión de presupuesto de mantenimiento',
    fecha: '25/09/2026',
    hora: '19:00',
    lugar: 'Google Meet',
    modalidad: 'Virtual',
    descripcion: 'Revisión y aprobación del presupuesto anual de mantenimiento propuesto por la tesorería.',
    estado: 'Próxima',
    asistentesConfirmados: 3,
    totalParticipantes: 6,
    agenda: ['Presupuesto anual 2027', 'Cotizaciones de proveedores'],
    participantes: [
      { name: 'Roberto Fuentes Salinas', cargo: 'Presidente', asistencia: 'Confirmado' },
      { name: 'Marcela Duarte Reyes', cargo: 'Tesorero', asistencia: 'Confirmado' },
      { name: 'Luis Fernando Ortiz', cargo: 'Secretario', asistencia: 'Confirmado' },
      { name: 'Adriana Cess Nájera', cargo: 'Vicepresidente', asistencia: 'Sin responder' },
      { name: 'Jorge Iván Camacho', cargo: 'Vocal', asistencia: 'Sin responder' },
      { name: 'Paola Ibarra Solís', cargo: 'Vocal', asistencia: 'Sin responder' }
    ],
    acuerdosGeneradosIds: []
  },
  {
    id: 3,
    titulo: 'Sesión Extraordinaria — Seguridad',
    fecha: '10/09/2026',
    hora: '18:30',
    lugar: 'Caseta principal',
    modalidad: 'Presencial',
    descripcion: 'Revisión de incidentes de acceso no autorizado reportados durante la primera semana de septiembre.',
    estado: 'Finalizada',
    asistentesConfirmados: 6,
    totalParticipantes: 6,
    agenda: ['Incidentes de acceso no autorizado', 'Cámaras de vigilancia'],
    participantes: [
      { name: 'Roberto Fuentes Salinas', cargo: 'Presidente', asistencia: 'Asistió' },
      { name: 'Adriana Cess Nájera', cargo: 'Vicepresidente', asistencia: 'Asistió' },
      { name: 'Luis Fernando Ortiz', cargo: 'Secretario', asistencia: 'Asistió' },
      { name: 'Marcela Duarte Reyes', cargo: 'Tesorero', asistencia: 'Asistió' },
      { name: 'Jorge Iván Camacho', cargo: 'Vocal', asistencia: 'Asistió' },
      { name: 'Paola Ibarra Solís', cargo: 'Vocal', asistencia: 'Asistió' }
    ],
    acuerdosGeneradosIds: [3]
  },
  {
    id: 4,
    titulo: 'Sesión Ordinaria — Agosto',
    fecha: '20/08/2026',
    hora: '18:00',
    lugar: 'Salón de usos múltiples',
    modalidad: 'Presencial',
    descripcion: 'Sesión ordinaria mensual de agosto.',
    estado: 'Finalizada',
    asistentesConfirmados: 6,
    totalParticipantes: 6,
    agenda: ['Contrato de vigilancia', 'Reglamento de mascotas'],
    participantes: [
      { name: 'Roberto Fuentes Salinas', cargo: 'Presidente', asistencia: 'Asistió' },
      { name: 'Adriana Cess Nájera', cargo: 'Vicepresidente', asistencia: 'Asistió' },
      { name: 'Luis Fernando Ortiz', cargo: 'Secretario', asistencia: 'Asistió' },
      { name: 'Marcela Duarte Reyes', cargo: 'Tesorero', asistencia: 'Asistió' },
      { name: 'Jorge Iván Camacho', cargo: 'Vocal', asistencia: 'Asistió' },
      { name: 'Paola Ibarra Solís', cargo: 'Vocal', asistencia: 'Asistió' }
    ],
    acuerdosGeneradosIds: [4]
  },
  {
    id: 5,
    titulo: 'Sesión Ordinaria — Julio',
    fecha: '16/07/2026',
    hora: '18:00',
    lugar: 'Salón de usos múltiples',
    modalidad: 'Presencial',
    descripcion: 'Sesión cancelada por falta de quórum.',
    estado: 'Cancelada',
    asistentesConfirmados: 0,
    totalParticipantes: 6,
    agenda: ['Tarifas de casa club'],
    participantes: [],
    acuerdosGeneradosIds: [5]
  }
]

export const acuerdos = [
  { id: 1, titulo: 'Renovación de contrato con empresa de vigilancia', descripcion: 'Evaluar tres propuestas de empresas de vigilancia y renovar o sustituir el contrato vigente antes de que termine el mes.', reunionId: 4, reunionTitulo: 'Sesión Ordinaria — Agosto', responsable: 'Roberto Fuentes Salinas', fechaCreacion: '20/08/2026', fechaLimite: '30/09/2026', estado: 'En proceso' },
  { id: 2, titulo: 'Instalación de cámaras adicionales en acceso norte', descripcion: 'Cotizar e instalar dos cámaras adicionales en el acceso norte tras los incidentes reportados.', reunionId: 3, reunionTitulo: 'Sesión Extraordinaria — Seguridad', responsable: 'Jorge Iván Camacho', fechaCreacion: '10/09/2026', fechaLimite: '15/10/2026', estado: 'Pendiente' },
  { id: 3, titulo: 'Actualización del reglamento de mascotas', descripcion: 'Actualizar el reglamento de mascotas conforme a la nueva campaña de vacunación.', reunionId: 4, reunionTitulo: 'Sesión Ordinaria — Agosto', responsable: 'Marcela Duarte Reyes', fechaCreacion: '20/08/2026', fechaLimite: '05/09/2026', estado: 'Completado' },
  { id: 4, titulo: 'Cotización para poda de áreas verdes', descripcion: 'Solicitar al menos dos cotizaciones para el servicio trimestral de poda de áreas verdes.', reunionId: 5, reunionTitulo: 'Sesión Ordinaria — Julio', responsable: 'Paola Ibarra Solís', fechaCreacion: '16/07/2026', fechaLimite: '20/09/2026', estado: 'Pendiente' },
  { id: 5, titulo: 'Revisión de tarifas de casa club', descripcion: 'Revisar si las tarifas actuales de casa club siguen siendo competitivas.', reunionId: 5, reunionTitulo: 'Sesión Ordinaria — Julio', responsable: 'Luis Fernando Ortiz', fechaCreacion: '16/07/2026', fechaLimite: '30/08/2026', estado: 'Cancelado' }
]

export const votaciones = [
  {
    id: 1,
    tema: 'Aprobación de presupuesto anual de mantenimiento 2027',
    descripcion: 'Se somete a votación el presupuesto anual de mantenimiento propuesto por la tesorería para el ejercicio 2027.',
    fechaInicio: '13/09/2026',
    fechaCierre: '20/09/2026',
    estado: 'Abierta',
    votos: {
      'Roberto Fuentes Salinas': 'A favor',
      'Adriana Cess Nájera': 'A favor',
      'Luis Fernando Ortiz': 'A favor',
      'Marcela Duarte Reyes': 'A favor',
      'Jorge Iván Camacho': 'En contra',
      'Paola Ibarra Solís': 'Pendiente'
    }
  },
  {
    id: 2,
    tema: 'Cambio de empresa de vigilancia',
    descripcion: 'Votación para autorizar el cambio de la empresa de vigilancia actual por una nueva propuesta.',
    fechaInicio: '26/08/2026',
    fechaCierre: '02/09/2026',
    estado: 'Aprobada',
    votos: {
      'Roberto Fuentes Salinas': 'A favor',
      'Adriana Cess Nájera': 'A favor',
      'Luis Fernando Ortiz': 'A favor',
      'Marcela Duarte Reyes': 'A favor',
      'Jorge Iván Camacho': 'A favor',
      'Paola Ibarra Solís': 'En contra'
    }
  },
  {
    id: 3,
    tema: 'Ampliación de horario de casa club los domingos',
    descripcion: 'Votación para ampliar el horario de casa club los días domingo de 20:00 a 22:00 hrs.',
    fechaInicio: '20/08/2026',
    fechaCierre: '28/08/2026',
    estado: 'Rechazada',
    votos: {
      'Roberto Fuentes Salinas': 'En contra',
      'Adriana Cess Nájera': 'En contra',
      'Luis Fernando Ortiz': 'A favor',
      'Marcela Duarte Reyes': 'En contra',
      'Jorge Iván Camacho': 'A favor',
      'Paola Ibarra Solís': 'En contra'
    }
  },
  {
    id: 4,
    tema: 'Autorización de gasto extraordinario para bacheo',
    descripcion: 'Autorización de un gasto extraordinario para la reparación de baches en las calles internas.',
    fechaInicio: '22/09/2026',
    fechaCierre: '29/09/2026',
    estado: 'Pendiente',
    votos: {
      'Roberto Fuentes Salinas': 'Pendiente',
      'Adriana Cess Nájera': 'Pendiente',
      'Luis Fernando Ortiz': 'Pendiente',
      'Marcela Duarte Reyes': 'Pendiente',
      'Jorge Iván Camacho': 'Pendiente',
      'Paola Ibarra Solís': 'Pendiente'
    }
  }
]

export const solicitudes = [
  { id: 1, tipo: 'Solicitud de evento', solicitante: 'Fam. Herrera · Casa 145', descripcion: 'Autorización para evento privado en salón de usos múltiples el sábado 26 de septiembre.', fecha: '12/09/2026', prioridad: 'Media', estado: 'Pendiente', historial: [{ fecha: '12/09/2026 10:20', texto: 'Solicitud recibida' }] },
  { id: 2, tipo: 'Solicitud de mantenimiento especial', solicitante: 'Áreas comunes', descripcion: 'La bomba principal de la alberca dejó de funcionar el 13 de septiembre. Se requiere autorización para gasto extraordinario de reparación con proveedor externo.', fecha: '14/09/2026', prioridad: 'Alta', estado: 'Pendiente', historial: [{ fecha: '14/09/2026 09:12', texto: 'Solicitud recibida' }, { fecha: '14/09/2026 09:40', texto: 'Turnada a la Mesa Directiva' }] },
  { id: 3, tipo: 'Solicitud de modificación', solicitante: 'Sr. Ávila · Casa 88', descripcion: 'Permiso para instalar toldo en fachada exterior de la vivienda.', fecha: '08/09/2026', prioridad: 'Baja', estado: 'En revisión', historial: [{ fecha: '08/09/2026 12:00', texto: 'Solicitud recibida' }, { fecha: '09/09/2026 08:30', texto: 'En revisión por el comité' }] },
  { id: 4, tipo: 'Solicitud administrativa', solicitante: 'Administración', descripcion: 'Propuesta de aumento de cuota de mantenimiento para el ejercicio 2027.', fecha: '01/09/2026', prioridad: 'Alta', estado: 'Aprobada', historial: [{ fecha: '01/09/2026 09:00', texto: 'Solicitud recibida' }, { fecha: '05/09/2026 17:00', texto: 'Aprobada por la Mesa Directiva' }] },
  { id: 5, tipo: 'Solicitud de residente', solicitante: 'Sra. Beltrán · Casa 22', descripcion: 'Queja por ruido excesivo en área de alberca durante horario nocturno.', fecha: '13/09/2026', prioridad: 'Media', estado: 'Rechazada', historial: [{ fecha: '13/09/2026 20:15', texto: 'Solicitud recibida' }, { fecha: '14/09/2026 11:00', texto: 'Rechazada — fuera de horario de jurisdicción de la Mesa' }] }
]

export function estadoColor (estado) {
  switch (estado) {
    case 'Activo':
    case 'Completado':
    case 'Aprobada':
    case 'Aprobado':
    case 'Publicado':
    case 'Asistió':
    case 'Confirmado':
      return 'green'
    case 'Pendiente':
    case 'En revisión':
    case 'En proceso':
      return 'orange'
    case 'Próxima':
    case 'Abierta':
    case 'Programado':
      return 'blue'
    case 'Inactivo':
    case 'Cancelada':
    case 'Cancelado':
    case 'Rechazada':
    case 'Rechazado':
    case 'En contra':
      return 'red'
    case 'Finalizada':
    case 'Borrador':
    case 'Sin responder':
      return 'grey'
    default:
      return 'grey'
  }
}

export function prioridadColor (prioridad) {
  switch (prioridad) {
    case 'Alta': return 'red'
    case 'Media': return 'orange'
    case 'Baja': return 'blue-grey'
    default: return 'grey'
  }
}

export function initials (name) {
  return (name || '').split(' ').filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase()
}
